import React, { Component } from 'react';
import * as I18n from '../../utils/i18n';
import eventManager from '@alife/scc-event-manager/event-manager';
import safeGet from '../../utils/safe-get';
import {
  SkuAttrGroup,
  AttrType,
  SkuAttrColorValue,
  SkuAttrImageValue,
} from '../../business/sku';
// import initOldMarletAction from './old/index';
// import OldSourcingAction from './old/sourcing-sku';
import NoSkuQuantity from './quantity';
import Xman from '../../utils/xman';
import './index.scss';

interface SkuAttrsProps {
  skuAttrs: SkuAttrGroup[];
  skuInfoMap: any;
  ladderPriceViews: any[];
  mediaItems: any[];
  price: any;
  moq: number;
  logisticInfo: any;
}

interface SkuAttrValFrameProps {
  type: AttrType;
  name: string;
  data:
    | ({ id: number } & { groupId: number })
    | ({ id: number; color: string } & { groupId: number })
    | ({
        id: number;
        fileName: string;
        largeImage: string;
        smallImage: string;
      } & { groupId: number });
  defaultSelected: boolean;
  defaultUseable: boolean;
}

interface OldSkuAttrsInterface {
  inventory: any;
  i18n: any;
  productEncryptId: string;
  productId: number;
  companyId: number;
  price: any;
  moq: number;
  promotion: any;
  productIsMarketGoods: boolean;
  global: any;
  currencyRule: any;
  ladderPeriodList: any[];
}

class SourcingSkuAttrs extends React.Component<
  SkuAttrsProps & OldSkuAttrsInterface
> {
  container: React.RefObject<any>;
  constructor(props) {
    super(props);
    this.container = React.createRef();
  }
  componentDidMount() {
    const { i18n } = this.props;
    // new OldSourcingAction(this.container.current, i18n);
    import(/** sku-old-sourcing-sku */ './old/sourcing-sku').then(modulePkg => {
      const OldSourcingAction = modulePkg.default;
      new OldSourcingAction(this.container.current, i18n);
    });
  }
  render() {
    const skuAttrViews = this.props.skuAttrs || [];

    if (skuAttrViews.length === 0) return null;
    
    return (
      <div id="skuWrap" className="sku-wrap" ref={this.container}>
        {skuAttrViews.map((skuAttrView, index) => {
          const firstSkuItem = skuAttrView.values[0];
          let skuAttrId = skuAttrView.id;
          const skuAttrValueViews = skuAttrView.values;
          return (
            <dl
              className={`sku-attr-dl util-clearfix ${firstSkuItem.type}`}
              data-role="sku-attr-item"
              data-id={skuAttrView.id}
              key={index}
            >
              <dt className="name" title={skuAttrView.name}>
                {skuAttrView.name}:
              </dt>
              <dd className="sku-attr-val value util-clearfix">
                {skuAttrValueViews.map((skuAttrVal, attrIndex) => {
                  const skuAttrValType = skuAttrVal.type;
                  const skuAttrValId = skuAttrVal.id;
                  const skuAttrValGroupId = `${skuAttrId}:${skuAttrValId};`;
                  let skuAttrValText = false;
                  let skuAttrValColor = false;
                  let skuAttrValImage = false;
                  let typeFrame = '';

                  if (skuAttrValType === AttrType.TEXT) {
                    skuAttrValText = true;
                    typeFrame = 'text-frame';
                  } else {
                    typeFrame = 'picture-frame';
                    if (skuAttrValType === AttrType.COLOR) {
                      skuAttrValColor = true;
                    } else if (skuAttrValType === AttrType.IMAGE) {
                      skuAttrValImage = true;
                    }
                  }

                  let usableMark = '';

                  if (!skuAttrVal.usable) {
                    usableMark = 'sku-attr-val-frame-disabled';
                  }

                  let skuAttrValName = skuAttrVal.name;

                  return (
                    <span
                      data-role="sku-attr-val"
                      data-id={skuAttrValGroupId}
                      className={`sku-attr-val-frame ${typeFrame} ${usableMark}`}
                      key={skuAttrValGroupId}
                    >
                      {skuAttrValColor && (
                        <span
                          className="color"
                          style={{
                            backgroundColor: `${
                              (skuAttrVal as SkuAttrColorValue).color
                            }`,
                          }}
                          title={skuAttrValName}
                          key={skuAttrValGroupId}
                        />
                      )}
                      {skuAttrValImage && (
                        <img
                          width="30"
                          height="30"
                          src={(skuAttrVal as SkuAttrImageValue).smallImage}
                          title={skuAttrValName}
                          alt={skuAttrValName}
                          key={skuAttrValGroupId}
                        />
                      )}
                      {!skuAttrValColor && !skuAttrValImage && (
                        <span key={skuAttrValGroupId}>{skuAttrVal.name}</span>
                      )}
                      <span className="icon-sku-attr-val" />
                    </span>
                  );
                })}
              </dd>
            </dl>
          );
        })}
      </div>
    );
  }
}

class OldSkuAttrs extends React.Component<
  SkuAttrsProps & OldSkuAttrsInterface
> {
  componentDidMount() {
    const {
      ladderPeriodList,
      mediaItems = [],
      price = {},
      logisticInfo = {},
    } = this.props;
    const { batchNum, saleType, fixedPrice, promotionFixedPrice } = price;
    const { productLogisticsMode = '' } = logisticInfo;
    const firstImageItem = mediaItems[0];
    let productPicture = '';
    if (firstImageItem && firstImageItem.type === 'image') {
      productPicture = safeGet(firstImageItem, 'imageUrl.thumb');
    } else if (firstImageItem && firstImageItem.type === 'video') {
      productPicture = safeGet(firstImageItem, 'videoCoverUrl');
    }

    import(/** sku-init-old-market-action */ './old/index').then(modulePkg => {
      const initOldMarletAction = modulePkg.default;

      try {
        initOldMarletAction({
          // ...mockData,
          currencyRule: this.props.price.currencyRule,
          skuAttrViews: this.props.skuAttrs,
          inventoryData: this.props.inventory,
          visitCountry:this.props.global.visitCountry,
          skuInfoMap: this.getSkuMap(),
          i18n: this.props.i18n,
          batchNum,
          logisticsMethod: productLogisticsMode,
          saleType,
          detailEncryptId: this.props.productEncryptId,
          detailId: this.props.productId,
          productBargainBuysInfo: {},
          productCompanyId: this.props.companyId,
          productSamplingOrderQuantity: {},
          productSamplingTotalPrice: {},
          productLeadTimes: ladderPeriodList,
          productSubject: '',
          promotionPrice: {},
          price: promotionFixedPrice || fixedPrice,
          isOnePrice: !!fixedPrice, // 是否是一口价
          moq: this.props.moq,
          productPicture,
          inProcessActivitySellLimitByBuyer:
            this.props.promotion && this.props.promotion.availableActivity
              ? this.props.promotion.availableActivity.inTimeLimitCount
              : undefined,
          productIsLimitedOfActivity:
            this.props.promotion && this.props.promotion.availableActivity
              ? this.props.promotion.availableActivity.hasLimit
              : undefined,
          ladderPriceViews: this.props.price.productLadderPrices,
          showPromotionPrice:
            this.props.promotion && this.props.promotion.showPromotionPrice
              ? !!this.props.promotion.showPromotionPrice
              : false,
          productInprocessActivities:
            this.props.promotion && this.props.promotion.availableActivity
              ? !!this.props.promotion.availableActivity
              : false,
          quantityUnitComplexStr: this.props.price.unitEven,
          quantityUnitOddStr: this.props.price.unit,
          activityEndTime:
            this.props.promotion && this.props.promotion.availableActivity
              ? this.props.promotion.availableActivity.endTime
              : undefined,
          serverTime: this.props.global.serverTime,
        });
      } catch (error) {
        console.log(error);
      }
    });
  }

  getSkuMap() {
    const { skuInfoMap, price = {} } = this.props;
    const {
      fixedPrice,
      formatFixedPrice,
      promotionFixedPrice,
      formatPromotionFixedPrice,
    } = price;

    // 一口价逻辑
    if (fixedPrice && skuInfoMap) {
      Object.keys(skuInfoMap).forEach(skuInfoKey => {
        const skuInfoItem = skuInfoMap[skuInfoKey];
        skuInfoItem.price = promotionFixedPrice || fixedPrice;
        skuInfoItem.formatPrice = formatPromotionFixedPrice || formatFixedPrice;
      });
    }

    return skuInfoMap;
  }

  render() {
    let selectedGroupId = '';
    const skuAttrViews = this.props.skuAttrs || [];
    const skuInfoMap = this.getSkuMap();
    const ladderPriceViews = this.props.ladderPriceViews;
    const productIsMarketGoods = this.props.productIsMarketGoods;
    const { price = {}, moq, i18n } = this.props;
    const { batchNum, unitEven, saleType } = price;

    const isBatch = saleType === 'batch';

    // let isShowSkuMoreBtn = false;
    const lastSkuAttrView = skuAttrViews[skuAttrViews.length - 1];
    const btnVisible = lastSkuAttrView && lastSkuAttrView.values.length > 3;
    const skuMoreNum = lastSkuAttrView ? lastSkuAttrView.values.length : 0;

    return (
      <div id="skuWrap" className="sku-wrap">
        {isBatch ? (
          <dl className="ma-brief-item">
            <dt className="ma-brief-item-key"></dt>
            <dd className="ma-brief-item-value">
              1 {i18n['marketAction.lot']} ={' '}
              {`${i18n['marketAction_brief_lotText']} ${batchNum} ${unitEven}`}
            </dd>
          </dl>
        ) : null}

        {skuAttrViews.length === 0 ? (
          <NoSkuQuantity minOrder={moq} unitEven={price.unitEven} i18n={i18n} />
        ) : null}
        {skuAttrViews.map((skuAttrView, index) => {
          let isLastSkuAttr =
            index === skuAttrViews.length - 1 && productIsMarketGoods;

          let skuAttrId = skuAttrView.id;
          const firstSkuItem = skuAttrView.values[0];
          const skuAttrValueViews = skuAttrView.values;
          const isShowSkuMoreBtn =
            isLastSkuAttr && skuAttrValueViews.length > 3;
          return (
            <dl
              className={`sku-attr-dl util-clearfix ${firstSkuItem.type}`}
              data-role={`${isLastSkuAttr ? 'last-sku-attr' : ''}`}
              key={index}
            >
              <dt className="name" title={skuAttrView.name}>
                {skuAttrView.name}:
              </dt>
              <dd className="sku-attr-val value util-clearfix">
                {skuAttrValueViews.map((skuAttrVal, attrIndex) => {
                  const skuAttrValType = skuAttrVal.type;
                  const skuAttrValId = skuAttrVal.id;
                  const skuAttrValGroupId = `${skuAttrId}:${skuAttrValId};`;
                  let skuAttrValText = false;
                  let skuAttrValColor = false;
                  let skuAttrValImage = false;
                  let typeFrame = '';

                  if (skuAttrValType === AttrType.TEXT) {
                    skuAttrValText = true;
                    typeFrame = 'text-frame';
                  } else {
                    typeFrame = 'picture-frame';
                    if (skuAttrValType === AttrType.COLOR) {
                      skuAttrValColor = true;
                    } else if (skuAttrValType === AttrType.IMAGE) {
                      skuAttrValImage = true;
                    }
                  }
                  // 如果存在多个sku属性，第一个sku属性的第一个值默认被选中，其他按照标示selected进行控制
                  let currentStatusMark = '';
                  if (attrIndex === 0) {
                    currentStatusMark = 'current-sku-attr-val';
                    if (!isLastSkuAttr) {
                      selectedGroupId = `${selectedGroupId}${skuAttrValGroupId}`;
                    }
                  }

                  let usableMark = '';
                  let usableQuantityMark = '';

                  if (!skuAttrVal.usable) {
                    if (!isLastSkuAttr) {
                      usableMark = 'sku-attr-val-frame-disabled';
                    } else {
                      usableMark = 'sku-attr-val-item-disabled';
                    }
                    usableQuantityMark = 'quantity-up-unusable';
                  }

                  let skuAttrValName = skuAttrVal.name;

                  const skuId = `${selectedGroupId}${skuAttrValGroupId}`;
                  const skuItem = skuInfoMap[skuId];
                  let price = '';

                  if (skuItem) {
                    if (skuItem.promotionPrice) {
                      price = skuItem.promotionPrice;
                    } else if (skuItem.formatPrice) {
                      price = skuItem.formatPrice;
                    } else {
                      price = skuItem.price;
                    }
                  } else {
                    price = '';
                  }

                  if (isLastSkuAttr) {
                    return (
                      <div
                        data-id={skuAttrValGroupId}
                        data-role="sku-attr-val"
                        className={`sku-attr-val-item  ${usableMark} ${
                          ladderPriceViews ? 'sku-attr-val-item-noprice' : ''
                        }`}
                        style={
                          attrIndex > 2 && isShowSkuMoreBtn
                            ? { display: 'none' }
                            : {}
                        }
                        key={skuAttrValGroupId}
                      >
                        <div
                          className={`sku-attr-val-last ${
                            skuAttrValColor
                              ? 'sku-attr-val-color'
                              : skuAttrValImage
                              ? 'sku-attr-val-img'
                              : 'sku-attr-val-text'
                          }`}
                        >
                          <span
                            className={`sku-attr-val-frame ${typeFrame}`}
                            title={skuAttrValName}
                          >
                            {skuAttrValColor ? (
                              <span
                                className="color"
                                style={{
                                  backgroundColor: `${
                                    (skuAttrVal as SkuAttrColorValue).color
                                  }`,
                                }}
                              />
                            ) : skuAttrValImage ? (
                              <img
                                width="30"
                                height="30"
                                src={
                                  (skuAttrVal as SkuAttrImageValue).smallImage
                                }
                                alt={skuAttrValName}
                              />
                            ) : (
                              skuAttrValName
                            )}
                            <span className="icon-sku-attr-val" />
                          </span>
                        </div>
                        {ladderPriceViews ? (
                          <div className="sku-price">
                            <span
                              data-role="sku-price-item"
                              className="sku-price__sku-price-item"
                              style={
                                !skuAttrVal.usable ? { display: 'none' } : {}
                              }
                            >
                              {price}
                            </span>
                          </div>
                        ) : (
                          <div className="sku-price">
                            <div
                              data-role="sku-price-item"
                              className="sku-price__sku-price-item"
                              style={
                                !skuAttrVal.usable ? { display: 'none' } : {}
                              }
                            >
                              {price}
                            </div>
                          </div>
                        )}
                        <div
                          data-role="sku-quantity"
                          className="sku-quantity quantity-value"
                        >
                          <div style={{ display: 'inline-block' }}>
                            <a
                              className="btn-quantity quantity-down"
                              data-role="quantity-down"
                              data-spm-anchor-id="0.0.0.0"
                            >
                              <b>-</b>
                            </a>
                            <input
                              type="text"
                              defaultValue={0}
                              maxLength={6}
                              className="ui2-textfield ui2-textfield-single"
                              data-role="wholesale-order-quantity"
                              disabled={!skuAttrVal.usable}
                            />
                            <a
                              className={`btn-quantity quantity-up ${usableQuantityMark}`}
                              data-role="quantity-up"
                            >
                              <b>+</b>
                            </a>
                          </div>
                          {/* 库存展示 */}
                          <div
                            data-role="product-inventory"
                            className="product-inventory inventory-hide"
                          >
                            <span className="inventory-wrap">
                              <span data-role="inventory-count" />
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <span
                        data-role="sku-attr-val"
                        data-id={skuAttrValGroupId}
                        className={`sku-attr-val-frame ${typeFrame} ${currentStatusMark} ${usableMark}`}
                        key={skuAttrValGroupId}
                      >
                        {skuAttrValColor && (
                          <span
                            className="color"
                            style={{
                              backgroundColor: `${
                                (skuAttrVal as SkuAttrColorValue).color
                              }`,
                            }}
                            title={skuAttrValName}
                            key={skuAttrValGroupId}
                          />
                        )}
                        {skuAttrValImage && (
                          <img
                            width="30"
                            height="30"
                            src={(skuAttrVal as SkuAttrImageValue).smallImage}
                            title={skuAttrValName}
                            alt={skuAttrValName}
                            key={skuAttrValGroupId}
                          />
                        )}
                        {!skuAttrValColor && !skuAttrValImage && (
                          <span key={skuAttrValGroupId}>{skuAttrVal.name}</span>
                        )}
                        <span className="icon-sku-attr-val" />
                      </span>
                    );
                  }
                })}
              </dd>
            </dl>
          );
        })}
        <div key="more">
          {btnVisible && (
            <div
              data-role="sku-attr-btn"
              className="sku-attr-btn sku-show-more"
            >
              {(
                I18n.get('marketAction.showAllSkuOptions') || 'All {0} Options'
              ).replace('{0}', skuMoreNum)}
              <i className="arrow ui2-icon ui2-icon-arrow-down ui2-icon-xxs" />
            </div>
          )}
        </div>
      </div>
    );
  }
}

interface ActivityCountDownInterface {
  itemPromotionActivity: any;
  warmUpActivity: any;
  unitEven: string;
  unit: string;
  warmUpActivityDefaultSellLimit: any;
  activityEndTime: any;
  showPromotionPrice: boolean;
  inProcessActivitySellLimitByBuyer: number;
  i18n: any;
  productIsLimitedOfActivity: any;
}
interface ActivityCountDownStateInterface {
  activitySellLimitText: string;
}
class ActivityCountDown extends React.Component<
  ActivityCountDownInterface,
  ActivityCountDownStateInterface
> {
  constructor(props) {
    super(props);
    this.state = {
      activitySellLimitText: '',
    };
  }
  componentDidMount() {
    const {
      unit,
      unitEven,
      inProcessActivitySellLimitByBuyer,
      i18n,
      showPromotionPrice,
      productIsLimitedOfActivity,
    } = this.props;
    const limitunit = inProcessActivitySellLimitByBuyer > 1 ? unitEven : unit;
    if (showPromotionPrice) {
      Xman(gXman => {
        const xman = new gXman.Popup({
          members: 'both',
          locale: 'en_US',
        });
        if (xman.isLoggedIn()) {
          this.setState({
            ...this.state,
            activitySellLimitText: `${
              i18n['marketAction_brief_loggedin_limit_text']
            } ${inProcessActivitySellLimitByBuyer} ${
              i18n['marketAction_brief_loggedin_limit_text_more']
            } ${limitunit.toLowerCase()}`,
          });
        } else {
          this.setState({
            ...this.state,
            activitySellLimitText: `${
              i18n['marketAction_brief_nologin_limit_text']
            } ${inProcessActivitySellLimitByBuyer} ${limitunit.toLowerCase()}`,
          });
        }
      });
    } else {
      if (productIsLimitedOfActivity) {
        this.setState({
          ...this.state,
          activitySellLimitText: `${i18n['marketAction_brief_limitActivity']}`,
        });
      } else {
        this.setState({
          ...this.state,
          activitySellLimitText: `${i18n['marketAction_brief_noLimitActivity']}`,
        });
      }
    }
  }
  render() {
    if (!this.props.showPromotionPrice) return null;
    const {
      itemPromotionActivity,
      warmUpActivity,
      unitEven,
      warmUpActivityDefaultSellLimit,
      activityEndTime,
      showPromotionPrice,
      inProcessActivitySellLimitByBuyer,
      i18n,
    } = this.props;
    const { activitySellLimitText } = this.state;
    return [
      <div
        key="promotion-banner"
        className="promotion-banner"
        id="detail-banner"
      />,
      <div key="activity">
        {warmUpActivity &&
          !itemPromotionActivity &&
          warmUpActivity.promotionContent &&
          warmUpActivity.startTime &&
          warmUpActivity.endTime && (
            <div className="promo-warmup">
              {i18n['promotion.warmup.descContent']
                .replace(
                  '${0}',
                  new Date(warmUpActivity.startTime).toLocaleDateString(),
                )
                .replace(
                  '${1}',
                  new Date(warmUpActivity.endTime).toLocaleDateString(),
                )}
              {warmUpActivity.definedLimitCount &&
                `, ${i18n['marketAction_activity_limit_to'].replace(
                  '${0}',
                  `${warmUpActivity.definedLimitCount} ${unitEven}`,
                )}`}
            </div>
          )}
      </div>,
      <div
        key="activityCountdown"
        id="activityCountdown"
        className="countdown activity-end-time"
      >
        <span className="title">
          <b>
            {itemPromotionActivity.promotionContent}%{' '}
            {i18n['marketAction_activity_off']}
          </b>
          &nbsp;{i18n['marketAction_activity_endTime']}
        </span>
        <i className="ui2-icon ui2-icon-clock"></i>
        <span className="wrap">
          <em className="day time-item" data-role="day"></em>
          <span className="time-division">:</span>
          <em className="hour time-item" data-role="hour"></em>
          <span className="time-division">:</span>
          <em className="minute time-item" data-role="minute"></em>
          <span className="time-division">:</span>
          <em className="second time-item" data-role="second"></em>
        </span>
      </div>,
    ];
  }
}

export default class SkuAttrs extends Component<
  SkuAttrsProps & OldSkuAttrsInterface
> {
  componentDidMount() {
    const log = txt => params => console.log('from pdp', txt, params);
    eventManager.on('init', log('init'));
    eventManager.on('calchange', log('calchange'));
    eventManager.on('expressConfirm', log('expressConfirm'));
    eventManager.on('logisticsChange', log('logisticsChange'));
    eventManager.on('logisticsChange:empty', log('logisticsChange:empty'));
    eventManager.on('leadtimeChange', log('leadtimeChange'));
    eventManager.on('cartWarning', log('cartWarning'));
    eventManager.on('moqWarning', log('moqWarning'));
    // eventManager.on('floatSideActionChange', throttle(this.handleFloatChange, 500));
    eventManager.on('addCartSucess', log('addCartSucess'));
    eventManager.on(
      'displayRightActionMoqWarning',
      log('displayRightActionMoqWarning'),
    );
  }
  render() {
    const { props } = this;
    const { productIsMarketGoods, i18n, promotion, price } = props;
    return (
      <div
        data-role="widget-main-action"
        className="widget-main-action widget-main-action-ws module-mainAction-lite module-mainAction-lite-vb detail-mainscreen-center-grid"
      >
        {productIsMarketGoods && promotion && (
          <ActivityCountDown
            i18n={i18n}
            itemPromotionActivity={promotion.availableActivity}
            warmUpActivity={promotion.warmUpActivity}
            unitEven={price.unitEven}
            unit={price.unit}
            productIsLimitedOfActivity={
              this.props.promotion && this.props.promotion.availableActivity
                ? this.props.promotion.availableActivity.hasLimit
                : undefined
            }
            warmUpActivityDefaultSellLimit={
              promotion.warmUpActivity
                ? promotion.warmUpActivity.definedLimitCount
                : undefined
            }
            activityEndTime={promotion.availableActivity.endTime}
            showPromotionPrice={promotion.showPromotionPrice}
            inProcessActivitySellLimitByBuyer={
              promotion.availableActivity
                ? promotion.availableActivity.inTimeLimitCount
                : undefined
            }
          />
        )}
        <div
          className="ma-brief-list ma-main-brief-list"
          data-role="ma-brief-list"
        >
          {productIsMarketGoods && <div id="activityCountdown"></div>}
          {productIsMarketGoods && <OldSkuAttrs {...this.props} />}
          {!productIsMarketGoods && <SourcingSkuAttrs {...this.props} />}
          {productIsMarketGoods && (
            <div className="ma-operate">
              {/* <div id="productCalculator"></div> */}
              <button
                id="J-btn-order"
                data-domdot="id:3330"
                data-dot="d_type=place_order&cid=3330&product_desc=wholesale"
                data-spm-click="gostr=/sc;locaid=d1000"
              >
                delegate start order
              </button>
              <button id="J-btn-shopping-cart" data-spm="1001">
                delegate cart
              </button>
            </div>
          )}
        </div>
        {productIsMarketGoods && (
          <div
            id="productCalculator"
            className="product-calculator ma-brief-list"
          >
            <div className="product-total-price">total_price</div>
            <div data-role="view-details-btn" className="view-details-btn">
              view_details
              <span className="arrow ui2-icon ui2-icon-xxs ui2-icon-arrow-down"></span>
              <span className="arrow ui2-icon ui2-icon-xxs ui2-icon-arrow-up"></span>
            </div>
            <div
              data-role="selected-product-list"
              className="selected-product-list"
            ></div>
          </div>
        )}
      </div>
    );
  }
}
